import React from 'react';
import { Link } from 'react-router-dom';
import { Sprout, CheckCircle2 } from 'lucide-react';
import { SITE_IMAGES } from '../../components/siteImages';
export function KidsMiniTroopers() {
  return <section className="py-24 bg-off-white" data-id="element-1962">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1963">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-1964">
          <div data-id="element-1965">
            <img src={SITE_IMAGES.miniTroopers} alt="Mini Troopers preschool Taekwondo at Storm" className="block rounded-2xl shadow-xl w-full object-cover aspect-[4/3]" data-id="element-1966" />
          </div>
          <div data-id="element-1967">
            <div className="inline-flex items-center gap-2 bg-storm-red/10 text-storm-red px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide mb-4" data-id="element-1968">
              <Sprout className="w-3.5 h-3.5" data-id="element-1969" />
              Ages 3–5
            </div>
            <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1970">
              Mini Troopers
            </h2>
            <p className="text-lg text-gray-warm mb-6" data-id="element-1971">
              Mini Troopers is designed specifically for ages 3–5. Classes are
              short, fast-paced, and built around the way preschoolers actually
              learn — through games, repetition, and lots of positive coaching.
            </p>
            <ul className="space-y-3 mb-8" data-id="element-1972">
              {['Listening skills and following directions', 'Balance, coordination, and motor skills', 'Confidence to try new things and bounce back', 'Basic Taekwondo movements and respect for the mat', 'A foundation for moving into Kids Taekwondo at age 6'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1973">
                  <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0 mt-0.5" data-id="element-1974" />
                  <span className="text-ink" data-id="element-1975">{item}</span>
                </li>)}
            </ul>
            <Link to="/mini-troopers" className="text-storm-red font-bold hover:underline inline-flex items-center gap-1" data-id="element-1976">
              See the Mini Troopers Program →
            </Link>
          </div>
        </div>
      </div>
    </section>;
}